import classNames from 'classnames';
import React from 'react';
import BsFormGroup from 'react-bootstrap/FormGroup';
import FormLabel from './FormLabel';
import FormattedLabel from './FormattedLabel';
import styles from './FormControls.module.scss';

function FormGroup({
  controlId,
  label,
  labelSrOnly,
  labelClassName,
  fluid,
  horizontal,
  className,
  children
}) {
  return React.createElement(BsFormGroup, {
    className: classNames(className, styles.group, fluid && styles.fluid, horizontal && styles.horizontalGroup)
  }, label && React.createElement(FormLabel, {
    htmlFor: controlId,
    className: classNames(labelClassName, styles.label, labelSrOnly && 'sr-only')
  }, React.createElement(FormattedLabel, {
    label: label
  })), horizontal && (labelSrOnly || !label) && React.createElement("div", {
    className: classNames(labelClassName, styles.label)
  }), children);
}

export default FormGroup;